import React from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import KwPanel from '../../common/KwPanel';

import { toast } from 'react-toastify';
import Button from '../../common/Button';
import ConfirmationHeader from '../../common/ConfirmationHeader';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../hooks';
import { deleteGameFranchise } from '../../../reducers/gameReducer';

export interface DeleteGameFranchiseProps {
    id: string;
    cancel: () => void;
    done: () => void;
}
function DeleteGameFranchise({ id, cancel, done }: DeleteGameFranchiseProps) {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const handleDelete = () => {
        dispatch(deleteGameFranchise(id))
            .then(() => {
                toast.success(t('Franchise successfully deleted'));
                done();
            })
            .catch(() => {
                toast.error(t('Failed to delete franchise'));
            });
    };
    return (<SlideoutLayout
        title={t('Delete confirmation')}
        cancel={cancel}
    >
        <KwPanel>
            <ConfirmationHeader text={t('Are you sure?')} />
            <Button
                className="btn btn-danger me-2"
                onClick={handleDelete}
                text={t('Yes, delete the franchise')}
            />
            <Button
                className="btn btn-default"
                onClick={cancel}
                autoFocus={true}
                text={t('No, cancel')}
            />
        </KwPanel>
    </SlideoutLayout>);
}


export default DeleteGameFranchise;